export enum BrowserType {
  Chrome = "chrome",
  Edge = "edge",
  Firefox = "firefox",
  Opera = "opera",
  Safari = "safari",
  InternetExplorer = "msie",
  Unknown = "unknown",
}
